module.exports = __webpack_public_path__ + "static/media/icons.32512bd3.svg";